// src/components/ConfirmModal.tsx

import React from 'react'
import {
    Alert,
    Button,
    Modal,
    Space,
    Typography
} from 'antd'
import {
    WarningOutlined
} from '@ant-design/icons'

import type { CSSProperties, ReactNode } from 'react'

const { Text } = Typography

interface ConfirmModalProps {
    isMobile?: boolean
    isOpen: boolean
    onRequestConfirm: () => void
    onRequestCancel: () => void
    title: string
    subtitle: string
    confirm: string
    cancel: string
    customStyles?: {
        content?: CSSProperties
        [key: string]: any
    }
    children?: ReactNode
}

interface ConfirmModalState {
}

class ConfirmModal extends React.Component<
    ConfirmModalProps,
    ConfirmModalState
> {

    render(): React.ReactNode {
        const {
            isMobile = false,
            isOpen,
            onRequestConfirm,
            onRequestCancel,
            title,
            subtitle,
            confirm,
            cancel,
            children
        } = this.props

        return (
            <Modal
                open={isOpen}
                onCancel={onRequestCancel}
                footer={null}
                title={title}
                centered
                width={isMobile ? 360 : 480}
                destroyOnHidden
            >
                <Space
                    direction="vertical"
                    size="middle"
                    style={{ width: '100%' }}
                >
                    <Alert
                        type="warning"
                        showIcon
                        icon={<WarningOutlined />}
                        message={subtitle}
                        description={
                            <Text>
                                {children}
                            </Text>
                        }
                    />

                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            gap: 8
                        }}
                    >
                        <Button
                            onClick={onRequestCancel}
                        >
                            {cancel}
                        </Button>

                        <Button
                            type="primary"
                            onClick={onRequestConfirm}
                        >
                            {confirm}
                        </Button>
                    </div>
                </Space>
            </Modal>
        )
    }
}

export default ConfirmModal